import { createRouter, createWebHashHistory } from "vue-router";
import { ROUTER, ROUTER_V1 } from "@/utils/type";
import { isOpenPaymentRouter } from "@/utils/tools";

const routes = [
  {
    path: ROUTER.MAIN,
    name: "home",
    component: () => import("../views/business_info/business_info.vue"),
    meta: {
      keepAlive: true, // 组件需要缓存
      title: "商户信息",
    },
  },
  {
    path: ROUTER.OPEN_PAYMENT,
    name: "open_payment",
    component: () => import("../views/open_payment/open_payment.vue"),
    meta: {
      title: "注册",
    },
  },
  {
    path: ROUTER.LOGIN,
    name: "login",
    component: () => import("../views/login/login.vue"),
    meta: {
      title: "登录",
    },
  },
  {
    path: ROUTER.REGISTER,
    name: "register",
    component: () => import("../views/register/register.vue"),
    meta: {
      title: "注册",
    },
  },
  {
    path: ROUTER.REGISTER2,
    name: "register2",
    component: () => import("../views/register_fz/register.vue"),
    meta: {
      title: "注册",
    },
  },
  {
    path: ROUTER.AGREEMENT,
    name: "agreement",
    component: () => import("../views/agreement/agreement.vue"),
    meta: {
      title: "协议",
    },
  },
  {
    path: ROUTER.HELPER,
    name: "business_instructions",
    component: () =>
      import("../views/business_instructions/business_instructions.vue"),
    meta: {
      keepAlive: true, // 组件需要缓存
      title: "操作说明",
    },
  },
  {
    path: ROUTER.BUSINESS_INFO_1,
    name: "business_Identity_01",
    component: () =>
      import("../views/business_Identity/business_Identity_01.vue"),
    meta: {
      keepAlive: true, // 组件需要缓存
      title: "经营信息",
    },
  },
  {
    path: ROUTER.BUSINESS_INFO_2,
    name: "business_Identity_02",
    component: () =>
      import("../views/business_Identity/business_Identity_02.vue"),
    meta: {
      keepAlive: true, // 组件需要缓存
      title: "身份资料",
    },
  },
  {
    path: ROUTER.BUSINESS_INFO_3,
    name: "business_Identity_03",
    component: () =>
      import("../views/business_Identity/business_Identity_03.vue"),
    meta: {
      keepAlive: true, // 组件需要缓存
      title: "收款卡信息",
    },
  },
  {
    path: ROUTER.BUSINESS_INFO_4,
    name: "business_Identity_04",
    component: () =>
      import("../views/business_Identity/business_Identity_04.vue"),
    meta: {
      keepAlive: true, // 组件需要缓存
      title: "营业执照信息",
    },
  },
  {
    path: ROUTER.AUTHORIZATION,
    name: "pay_authorization",
    component: () => import("../views/pay_authorization/pay_authorization.vue"),
    meta: {
      keepAlive: true, // 组件需要缓存
      title: "认证方式",
    },
  },
  {
    path: ROUTER.WX_AUDIT,
    name: "pay_audit",
    component: () => import("../views/pay_audit/pay_audit.vue"),
    meta: {
      keepAlive: true, // 组件需要缓存keepAlive: true, // 组件需要缓存
      title: "微信审核",
    },
  },
  {
    path: ROUTER.A_LI_AUDIT,
    name: "pay_audit_ali",
    component: () => import("../views/pay_audit/pay_audit_ali.vue"),
    meta: {
      keepAlive: true, // 组件需要缓存keepAlive: true, // 组件需要缓存
      title: "支付宝审核",
    },
  },
];

const routesV1 = [
  {
    path: ROUTER.MAIN,
    name: "home",
    component: () => import("../views/business_info/business_info.vue"),
    meta: {
      keepAlive: true, // 组件需要缓存
      title: "商户信息",
    },
  },
  {
    path: ROUTER_V1.REGISTER,
    name: "open_payment",
    component: () => import("../views/register/register_v1.vue"),
    meta: {
      title: "注册",
    },
  },
  {
    path: ROUTER.LOGIN,
    name: "login",
    component: () => import("../views/login/login.vue"),
    meta: {
      title: "登录",
    },
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes: isOpenPaymentRouter() ? routes : routesV1,
});

export default router;
